import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { TestimonialCard } from './TestimonialCard';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
export function SocialProofSection() {
  const testimonials = [{
    initials: 'MG',
    quote: 'En 3 días dejé de sentirme hinchada después de cada comida. El workbook me hizo entender qué estaba haciendo mal.',
    name: 'Mariana G.',
    location: 'Córdoba'
  }, {
    initials: 'LP',
    quote: 'Por fin un método que explica POR QUÉ pasan las cosas. No solo qué comer. Entendí mi cuerpo de una manera que no había logrado antes.',
    name: 'Laura P.',
    location: 'Rosario'
  }, {
    initials: 'RM',
    quote: 'El plan de 14 días me organizó la cabeza. Antes improvisaba todo. Ahora tengo un sistema y mi energía cambió completamente.',
    name: 'Roberto M.',
    location: 'Buenos Aires'
  }];
  return <SectionWrapper className="bg-white" data-id="element-253">
      <div className="text-center mb-12" data-id="element-254">
        <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-primary/10 text-primary mb-4" data-id="element-255">
          <ChatBubbleOutlineIcon data-id="element-256" />
        </div>
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-primary mb-4" data-id="element-257">
          LO QUE DICEN QUIENES YA LO VIVIERON
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-258">
        {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-259" />)}
      </div>
    </SectionWrapper>;
}